import LoadingScreen from "components/LoadingScreen";
import AuthGuard from "guard/AuthGuard";
import GuestGuard from "guard/GuestGuard";
import AuthLayout from "layouts/AuthLayout";
import DashboardLayout from "layouts/DashboardLayout";
import OnboardingLayout from "layouts/OnboardingLayout";
// import CreateCorrectiveInvoice from "pages/ManualDocument/AP/verifactu/correctiveInvoice";
// import CreateVerifacturaCreditNote from "pages/ManualDocument/AP/verifactu/creditNote";
// import CreateVerifacturaDebitNote from "pages/ManualDocument/AP/verifactu/debitNote";
// import CreateVerifactuRegular from "pages/ManualDocument/AP/verifactu/regularInvoice";
// import CreateVerifacturaSimplifiedInvoice from "pages/ManualDocument/AP/verifactu/simplifiedInvoice";
import { ElementType, Suspense } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import lazyWithRetry from "./../lazyWithRetry";

const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen isDashboard={true} />}>
      <Component {...props} />
    </Suspense>
  );
};

const Page404 = Loadable(lazyWithRetry(() => import("pages/Page404")));
const Profile = Loadable(lazyWithRetry(() => import("pages/accounts")));
const Transactions = Loadable(
  lazyWithRetry(() => import("pages/transactions")),
);
const Queries = Loadable(lazyWithRetry(() => import("pages/queries")));
const Onboarding = Loadable(lazyWithRetry(() => import("pages/onboarding")));
const DocumentList = Loadable(
  lazyWithRetry(() => import("pages/supplier_page")),
);

const EmailPageContainer = Loadable(
  lazyWithRetry(
    () => import("../pages/email_send_page/skeleton/EmailPageContainer"),
  ),
);
const ImpersonateSupplier = Loadable(
  lazyWithRetry(() => import("../pages/impersonate")),
);
const CreateManualDeliveryNoteV2 = Loadable(
  lazyWithRetry(
    () => import("../pages/ManualDocumentV2/forms/AR/deliveryNote"),
  ),
);

const DeliveryNoteWrapper = () => {
  const supplier = useSelector((state: any) => state.supplier.supplier);

  return true ? <CreateManualDeliveryNoteV2 /> : <CreateManualDeliveryNoteV2 />;
};

const Router = () => {
  const supplierId = localStorage.getItem("supplierId");
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path=""
          element={
            <GuestGuard>
              <AuthLayout />
            </GuestGuard>
          }
        >
          <Route path="/:id" element={<EmailPageContainer />} />
          <Route path="/" element={<EmailPageContainer />} />
        </Route>

        <Route
          path=""
          element={
            <AuthGuard>
              <OnboardingLayout />
            </AuthGuard>
          }
        >
          <Route path="/:id/onboarding" element={<Onboarding />} />
        </Route>

        <Route
          path=""
          element={
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          }
        >
          <Route
            path="/:id/documents/create-delivery-note"
            element={<DeliveryNoteWrapper />}
          />
          <Route path="/:id/documents" element={<DocumentList />} />
          <Route path="/:id/account" element={<Profile />} />
          <Route path="/:id/transactions" element={<Transactions />} />
          <Route path="/:id/queries" element={<Queries />} />
        </Route>

        <Route path="/:id/impersonate" element={<ImpersonateSupplier />} />
        <Route
          path="/:id"
          element={
            <GuestGuard>
              <EmailPageContainer />
            </GuestGuard>
          }
        />
        <Route path="/:id/404" element={<Page404 />} />
        <Route path="/404" element={<Page404 />} />
        <Route
          path="*"
          element={
            <Navigate to={supplierId ? `${supplierId}/404` : "/404"} replace />
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
